export const GRADING_RANGE_MAX = 10;
export const GRADING_RANGE_MIN = 0;

export const TOAST_AUTO_CLOSE_MS = 2000;

export const MAX_GRADED_QUIZ_ATTEMPT = 2;
